import * as React from "react"
import {Skeleton} from "@mui/material"
import {AppTable} from "@components";

import {WEBBACK_V2_API, DATE_METRICS} from "@constants"
import {useToast, useUserApp} from "@hooks";
import {isLoadingCommonFilters} from "@signals"
import {useMonitoringResultsTableFilters} from "../@hooks";
import {
    monitoringResultsTableBrandFilter,
    monitoringResultsTableEANFilter,
    monitoringResultsTableFirstMoverFilter,
    monitoringResultsTableOutOfStockFilter,
    monitoringResultsTableRefFilter,
    monitoringResultsTableRestockedFilter,
    monitoringResultsTableUnderPriceFilter,
    monitoringResultsTableProductFilter
} from "../@signals"
import {dataColumn, iconFiltersColumn, productColumn, retailerColumn} from "./columns"
import MonitoringResultsTableToolbar from "./Toolbar";
import MonitoringResultsTableLoadingTab from "./LoadingTab";
import MonitoringResultsTableExcelButton from "./ExcelButton";


const TITLE = "FREQUENCY MONITORING"

export default function MonitoringResultsTable() {
    const { showToast } = useToast()
    const { userGroupByProductID } = useUserApp()
    const {
        monitoringTableData, monitoringTableSites, monitoringTableMetric, monitoringTableDates, monitoringTableCountrySelected,
        monitoringTableCountries, handleChangeCountrySelected, showTable, showMinMaxPrices, monitoringTableFilledData
    } = useMonitoringResultsTableFilters()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={700} />
    if (!monitoringTableData.length) return <></>
    if (!showTable) return <MonitoringResultsTableLoadingTab
        title={TITLE}
        monitoringTableCountries={monitoringTableCountries}
        monitoringTableCountrySelected={monitoringTableCountrySelected}
    />

    const showVariants = !userGroupByProductID

    const columns = [
        ...productColumn({ showMinMaxPrices }),
        retailerColumn(monitoringTableSites, monitoringTableFilledData)
    ]

    if (monitoringTableMetric === DATE_METRICS.HOURLY) {
        monitoringTableDates.forEach(dateObj => {
            columns.push(dataColumn(dateObj, monitoringTableMetric, monitoringTableSites, monitoringTableFilledData, showVariants))
        })
    } else
        monitoringTableDates.forEach(date => columns.push(dataColumn(date, monitoringTableMetric, monitoringTableSites, monitoringTableFilledData, showVariants)))

    const handleDownload = (extraData) => showToast.promiseExcel(`${WEBBACK_V2_API}/monitoring/results/excel`, extraData)

    return <AppTable
        data={monitoringTableData}
        title={TITLE}
        columns={[
            ...columns,
            ...iconFiltersColumn()
        ]}
        renderExcelButton={() => <MonitoringResultsTableExcelButton onDownload={handleDownload} />}
        options={{
            customToolbar: () => <MonitoringResultsTableToolbar
                countries={monitoringTableCountries}
                countrySelected={monitoringTableCountrySelected}
                onChange={handleChangeCountrySelected}
            />,
            enhancedSetRowProps: (_, __, rowIndex) => ({
                sx: { backgroundColor: rowIndex % 2 === 0 ? 'background.paper' : "#fafafa" }
            }),
            onFilterChange: (changedColumn, filterList, _, dataIdx) => {
                if (changedColumn === 'brand') {
                    console.log(filterList, dataIdx, filterList[dataIdx])
                    monitoringResultsTableBrandFilter.value = filterList[dataIdx]
                }
                else if (changedColumn === 'ean')
                    monitoringResultsTableEANFilter.value = filterList[dataIdx]
                else if (changedColumn === 'reference')
                    monitoringResultsTableRefFilter.value = filterList[dataIdx]
                else if (changedColumn === 'sku')
                    monitoringResultsTableProductFilter.value = filterList[dataIdx]
                else if (changedColumn === 'hasFirstMover')
                    monitoringResultsTableFirstMoverFilter.value = filterList[dataIdx]
                else if (changedColumn === 'hasUnderPrice')
                    monitoringResultsTableUnderPriceFilter.value = filterList[dataIdx]
                else if (changedColumn === 'hasRestocked')
                    monitoringResultsTableRestockedFilter.value = filterList[dataIdx]
                else if (changedColumn === 'hasOOS')
                    monitoringResultsTableOutOfStockFilter.value = filterList[dataIdx]
            },
        }}
    />
}
